import * as analytics from '@cartwheel/analytics'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['trigger', 'value']
  static values = {
    tooltipDefault: { type: String, default: 'Click to copy' },
    tooltipCopied: { type: String, default: 'Copied' },
    tooltipId: { type: String, default: 'tooltip' },
    trackingEvent: { type: String, default: '' },
  }

  connect() {
    if (this.triggerTargets.length !== this.valueTargets.length) return

    this.abortController = new AbortController()
    const signal = this.abortController.signal

    this.triggerTargets.forEach((trigger, index) => {
      const tooltip = document.getElementById(this.tooltipIdValue)
      if (!tooltip) return

      const textNode = tooltip.childNodes[0]

      trigger.addEventListener(
        'click',
        () => {
          const valueTarget = this.valueTargets[index]
          const value = valueTarget.innerText || valueTarget.value
          navigator.clipboard.writeText(value).then(() => {
            textNode.nodeValue = this.tooltipCopiedValue

            if (this.trackingEventValue) {
              console.log('tracking event', this.trackingEventValue)
              analytics.track(this.trackingEventValue)
            }
          })
        },
        { signal }
      )

      trigger.addEventListener(
        'mouseleave',
        () => {
          textNode.nodeValue = this.tooltipDefaultValue
        },
        { signal }
      )
    })
  }

  disconnect() {
    this.abortController?.abort()
  }
}
